import { useEffect, useState } from 'react';
import api from '../../../../utils/api';
import { PartnerEndpoints } from '../../../../utils/endpoints';

// A failure only hides the selector: the page's own request reports errors, deactivation included.
const useOwnPans = ({ enabled = true } = {}) => {
  const [pans, setPans] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    api
      .get(PartnerEndpoints.ownPans)
      .then((response) => {
        if (!cancelled) setPans(Array.isArray(response?.data?.data) ? response.data.data : []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return pans;
};

export default useOwnPans;
